import { render, staticRenderFns } from "./Edicion.vue?vue&type=template&id=2e466a62&"
import script from "./Edicion.vue?vue&type=script&lang=js&"
export * from "./Edicion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports